import React, { Component } from 'react'
import { Card } from '@myxplor/ui'
import { withRouter } from 'react-router-dom'
import { toProviderRegistrations } from '../../navigate'
import RemoteRequest from '../../remote-request'

import DeviceRegistration from './device-registration'
import ProviderDetailsForm from './views/provider-details-form'
import SuccessView from './views/success'

const defaultState = {
  registration_details: {
    organisation_id: '',
    provider_id: '',
    personnel_id: '',
  },
  device_registration_missing: false,
  completed: false,
  error: undefined
}

const submitRegistrationEndpoint = (care_provider_id) => (
  process.env.REACT_APP_API_HOST + `/api/providers/${care_provider_id}/provider-registration-details`
)

export const isEmptyArray = (val) => (
  Array.isArray(val) && val.length === 0
)

export const calculateState = (state) => (
  {
    completed: !isEmptyArray(state.data),
    device_registration_missing: state.errors === 'missing-device-registration',
    error: state.errors
  }
)

class ProviderOnboarding extends Component {
  constructor(props) {
    super(props)
    this.state = props.defaultState || defaultState
    this.onDeviceRegistered = this.onDeviceRegistered.bind(this)
    this.onDeviceRegistrationError = this.onDeviceRegistrationError.bind(this)
    this.submitRegistration = this.submitRegistration.bind(this)
    this.onRegistrationComplete = this.onRegistrationComplete.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.remote_request !== this.props.remote_request) {
      this.setState(calculateState(this.props.remote_request.state))
    }
  }

  submitRegistration(registration_details) {
    this.setState({ registration_details })
    this.props.remote_request.submit(
      submitRegistrationEndpoint(this.props.id),
      {
        method: 'POST',
        jsonAPI: true,
        body: registration_details
      })
  }

  onDeviceRegistered() {
    this.setState(
      { device_registration_missing: false },
      this.submitRegistration(this.state.registration_details)
    )
  }

  onDeviceRegistrationError(error) {
    this.setState({
      device_registration_missing: false,
      error: error
    })
  }

  onRegistrationComplete() {
    this.props.history.push(toProviderRegistrations(this.props.id))
  }

  viewComponent() {
    const {
      registration_details,
      device_registration_missing,
      completed,
    } = this.state

    const { loading, errors } = this.props.remote_request.state

    if (device_registration_missing) {
      return (
        <DeviceRegistration
          organisation_id={registration_details.organisation_id}
          onComplete={this.onDeviceRegistered}
          onError={this.onDeviceRegistrationError}
        />
      )
    } else if (completed) {
      return (
        <SuccessView
          onComplete={this.onRegistrationComplete}
        />)
    } else {
      return (
        <ProviderDetailsForm
          registration_details={registration_details}
          errors={this.state.error || errors}
          loading={loading}
          onSubmit={this.submitRegistration}
        />
      )
    }
  }

  render() {
    return <Card embedded={this.props.embedded}>{this.viewComponent()}</Card>
  }
}

export default withRouter(RemoteRequest(ProviderOnboarding))



// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/container.jsx